import React, { useEffect, useRef, useState } from "react";
import { socket } from "../../utils/customFn";
import "./contactsupport.scss";
import ChatUserList from "../../components/contactsupportchat/chatuserList";
import ChatWindow from "../../components/contactsupportchat/chatwindow";
import { TitleHeader } from "../../components";
import { useSelector } from "react-redux";
import { useSocket } from "../../context/SocketContext";

const ContactSupport = () => {
  const { socket } = useSocket();
  const { profileData } = useSelector((state) => state.userAuth);
  const [listData, setListData] = useState([]);
  const [otherUser, setOtherUser] = useState(null);
  const [messages, setMessages] = useState([]);
  const adminId = profileData?.id;
  
  const handleUserSelect = (user) => {
    setMessages([]);
    setListData((prevList) => {
      const userIndex = prevList.findIndex(
        (userDetails) => userDetails.id === user.id
      );

      if (userIndex === -1) {
        return prevList;
      }
      const updatedList = [...prevList];
      updatedList[userIndex] = {
        ...updatedList[userIndex],
        unreadCount: 0,
      };

      return updatedList;
    });

    socket.emit("contact_support_messages_read", {
      senderId: profileData?.id,
      receiverId: user.id,
    });

    setOtherUser(user);
  };

  const breadcrumbs = [
    { label: "Pages", link: "" },
    { label: "Add Page", link: "" },
  ];

  useEffect(() => {
    const adminId = profileData?.id;
    const handleNewMessage = (data) => {
      console.log("data", data, adminId);
      if (data.senderId != adminId && data?.senderId != otherUser?.id) {
        setListData((prevList) => {
          const userIndex = prevList.findIndex(
            (user) => user.id == data.senderId
          );

          if (userIndex === -1) {
            return prevList;
          }

          // Create new array with sender at top
          const updatedList = [...prevList];
          const [movedUser] = updatedList.splice(userIndex, 1);

          const updatedUser = {
            ...movedUser,
            unreadCount: movedUser?.unreadCount + 1,
          };

          return [updatedUser, ...updatedList];
        });
      }
    };

    socket.on("chat_support_msg", handleNewMessage);
    return () => socket.off("chat_support_msg", handleNewMessage);
  }, [profileData?.id, otherUser]);

  return (
    <>
      <TitleHeader heading="Contact supports" breadcrumbs={breadcrumbs} />
      <div className="chat-app">
        <ChatUserList
          onSelectUser={handleUserSelect}
          otherUser={otherUser}
          setOtherUser={setOtherUser}
          setListData={setListData}
          listData={listData}
        />

        <ChatWindow
          socket={socket}
          otherUser={otherUser}
          setMessages={setMessages}
          messages={messages}
          setListData={setListData}
        />
      </div>
    </>
  );
};

export default ContactSupport;
